export default {
    SET_CONTRACTORS(state, contractors) {
        state.contractors = contractors
    },

    SET_CONTRACTORS_TOTAL(state, total) {
        state.contractorsTotal = total
    },

    SET_ORIGINAL_CONTRACTOR(state, contractor) {
        state.originalContractor = contractor
    },
}
